// @flow

/**
 * This fixes the issue where browsers remember the previous user selection on dropdown. This is a problem
 * because when a user hit back button, the dropdown shows a the wrong default selection. Currently, pagination is
 * a dropdown so it has this problem.
 */
const initDropdowns = (win: WindowProxy) => {

  // no drop down if there's no results, i.e. https://www.reece.com.au/search/?query=9503162
  if(win.document.querySelector(".product-listing__pagination-control--page")) {
    const defaultIndex =  [...win.document.querySelector(".product-listing__pagination-control--page").children]
      .map((el, index) => ({selected: el.defaultSelected, index}))
      .filter(el => el.selected)[0].index;
    win.document.querySelector(".product-listing__pagination-control--page").selectedIndex = defaultIndex;
  }
};

export default initDropdowns;close



// WEBPACK FOOTER //
// ./javascript/product-search-page/dropdown-default-selection/index.js